import ApiBase from './ApiBase';

class StoreGroupApi {
  fetchAllStores() {
    return ApiBase.get('/stores'); // Fetch all stores
  }

  fetchStoreGroupings() {
    return ApiBase.get('/store_groupings'); // Fetch all store groupings
  }

  saveStoreGroupings(data) {
    return ApiBase.post('/store_groupings/create_or_update', { store_groupings: data }); // Save groupings
  }
}

export default new StoreGroupApi();
